export default "__VITE_ASSET__4e0e60cd__"